import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { HttpClientModule } from '@angular/common/http';

@Component({
  standalone: true,
  selector: 'app-modal-continue',
  templateUrl: './modal-continue.component.html',
  styleUrls: ['./modal-continue.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    I18NextModule,
    MatDialogModule,

    // TODO: `HttpClientModule` should not be imported into a component directly.
    // Please refactor the code to add `provideHttpClient()` call to the provider list in the
    // application bootstrap logic and remove the `HttpClientModule` import from this component.
    HttpClientModule
  ]
})
export class ModalContinueComponent {
  @Input() modalData = false;
  @Output() closeModalEmitter = new EventEmitter<void>();
  @Output() spinnerModalEmitter = new EventEmitter<boolean>(false);
  @Output() confirmCancelOrderEmitter = new EventEmitter<boolean>();

  spinner = false;
  stockVehicles = false;
  constructor(
    public dialogRef: MatDialogRef<ModalContinueComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}

  btnContinue() {
    this.dialogRef.close(true);
  }
  btnCancel() {
    this.dialogRef.close(false);
  }
}
